import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAcademicSessionsAsync } from "../../Redux/MasterSlice";
import BaseApi from "../../Http/BaseApi";

export default function VoucherPortal() {
  const [urlParams, setUrlParams] = useState({});
  const [selectedSession, setSelectedSession] = useState("");
  const dispatch = useDispatch();

  const formatAcademicLabel = (label = "") =>
    label.slice(0, 5) + label.slice(7); // "2025-2026" → "2025-26"

  // Get academicSessions from Redux store
  const academicSessions = useSelector(
    (state) => state.master.academicSessions
  );

  useEffect(() => {
    // Fetch academic sessions from API
    dispatch(getAcademicSessionsAsync());

    // get query params from url
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const error = params.get("error");
    setUrlParams({ error });
  }, [dispatch]);

  // Set default selection to the latest session when sessions are loaded
  useEffect(() => {
    if (academicSessions.length > 0) {
      // Filter sessions with ID >= 5
      const filteredSessions = academicSessions.filter(
        (session) => session.id >= 5
      );

      if (filteredSessions.length > 0) {
        // Find the session with the highest ID (latest session)
        const latestSession = filteredSessions.reduce((latest, current) =>
          current.id > latest.id ? current : latest
        );

        // Set the latest session as default
        setSelectedSession(latestSession.id.toString());
      }
    }
  }, [academicSessions]);

  const openVoucherPortal = async () => {
    // Validate session selection
    if (!selectedSession) {
      alert("Please select an financial year");
      return;
    }

    try {
      const user = JSON.parse(localStorage.getItem("userData"));
      const res = await BaseApi("staff").get("handoff-token");
      const token = res.data?.token;
      const staff_id = res.data?.staff_id || user?.user?.id;

      var form = document.createElement("form");
      form.setAttribute("method", "post");
      form.setAttribute("action", "https://vouchers.dibru.work/loginById");
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", "token");
      hiddenField.setAttribute("value", token);
      var hiddenField2 = document.createElement("input");
      hiddenField2.setAttribute("type", "hidden");
      hiddenField2.setAttribute("name", "staff_id");
      hiddenField2.setAttribute("value", staff_id);

      // Add academic_session_id field
      var hiddenField3 = document.createElement("input");
      hiddenField3.setAttribute("type", "hidden");
      hiddenField3.setAttribute("name", "academic_session_id");
      hiddenField3.setAttribute("value", selectedSession);

      form.appendChild(hiddenField);
      form.appendChild(hiddenField2);
      form.appendChild(hiddenField3);
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    } catch (_) {
      alert("Could not open voucher portal. Please login again.");
    }
  };

  return (
    <div className='m-10 text-center'>
      <p className='p-10 m-10 text-red-600'>{urlParams?.error}</p>

      {/* Academic session dropdown */}
      <div className='mb-4'>
        <label className='block mb-2 text-sm font-bold text-gray-700'>
          Select Financial Year
        </label>
        <select
          className='w-full max-w-xs px-3 py-2 mx-auto border rounded shadow appearance-none'
          value={selectedSession}
          onChange={(e) => setSelectedSession(e.target.value)}
        >
          <option value=''>Select Session</option>
          {academicSessions
            .filter((session) => session.id >= 5)
            .map((session) => (
              <option key={session.id} value={session.id}>
                {formatAcademicLabel(session.label)}
              </option>
            ))}
        </select>
      </div>

      <button
        onClick={openVoucherPortal}
        className='px-4 py-2 font-bold text-white bg-blue-500 rounded hover:bg-blue-700'
      >
        Open Voucher Portal
      </button>
    </div>
  );
}
